import { render, staticRenderFns } from "./AddPPM_control.vue?vue&type=template&id=46df6d34&scoped=true"
import script from "./AddPPM_control.vue?vue&type=script&lang=ts"
export * from "./AddPPM_control.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_control.vue?vue&type=style&index=0&id=46df6d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df6d34",
  null
  
)

export default component.exports